import React, { useEffect, useState } from 'react';
import Form from '../../../../components/forms/form';
import { Button } from '@syneto/compass-react';
import { reduxForm } from 'redux-form';
import PartnerPreviewFieldsValidation from './data/validation/partner-preview-fields';
import { getPartnerPreviewSettings, patchPartnerPreviewSettings } from '../../../../services/settings';
import { normalizeLearnMoreUrl } from '../../../../helpers/learnMoreUrl';
import { getApiErrorMessage } from '../../../../helpers/apiError';
import { pushDangerNotification, pushSuccessfulNotification } from '../../../../data/notifications/actions';

const FORM_NAME = 'partnerPreview';

let AdminSettingsPartnerPreviewTab = (props) => {
	const { handleSubmit, submitting, invalid, pristine, onSaved, reset, activeKey } = props;

	// Tab panes stay mounted, and enableReinitialize does nothing when the re-fetched value equals
	// the old one, so discard unsaved edits on tab entry like the sibling tabs do.
	useEffect(() => {
		activeKey === FORM_NAME && reset();
	}, [activeKey]);

	const submit = (formValues) => {
		const learnMoreUrl = normalizeLearnMoreUrl(formValues.partnerPreviewLearnMoreUrl);

		return patchPartnerPreviewSettings(learnMoreUrl)
			.then(() => {
				onSaved({ partnerPreviewLearnMoreUrl: learnMoreUrl });
				props.dispatch(pushSuccessfulNotification('Partner Preview settings updated.'));
			})
			.catch((error) => {
				props.dispatch(pushDangerNotification(getApiErrorMessage(error, 'Failed to save Partner Preview settings.')));
			});
	};

	return (
		<form className="mb-5">
			<fieldset className="mb-5">
				<h1 className="mb-1">Partner Preview Program</h1>
				<p className="text-secondary mb-4 text-value">
					Where the Learn More button on the Dashboard invitation banner points. Leave empty to hide the button.
				</p>
				<Form.text
					name="partnerPreviewLearnMoreUrl"
					label="Learn More URL"
					placeholder="https://"
				/>
			</fieldset>

			<Button disabled={submitting || invalid || pristine} onClick={handleSubmit(submit)} type="submit">
				{!submitting ? 'Save' : 'Saving...'}
			</Button>
		</form>
	);
};

AdminSettingsPartnerPreviewTab = reduxForm({
	form: FORM_NAME,
	enableReinitialize: true,
	validate: PartnerPreviewFieldsValidation.validate
})(AdminSettingsPartnerPreviewTab);

export default (props) => {
	const { activeKey } = props;
	const [initialValues, setInitialValues] = useState(null);
	const [error, setError] = useState(null);

	const load = () => {
		setError(null);
		getPartnerPreviewSettings()
			.then((response) => {
				setInitialValues({ partnerPreviewLearnMoreUrl: response.data?.partnerPreviewLearnMoreUrl ?? '' });
			})
			.catch((loadError) => {
				setInitialValues(null);
				setError(loadError);
			});
	};

	useEffect(() => {
		activeKey === FORM_NAME && load();
	}, [activeKey]);

	if (!initialValues) {
		if (error) {
			return <div>Could not load page. Error: {error.message}<Button role="link" className="ms-2" onClick={load}>Try again.</Button></div>;
		}

		return <div>Loading...</div>;
	}

	// The PATCH answers with a job, not the new settings, so the saved form values become the new baseline.
	return <AdminSettingsPartnerPreviewTab {...props} initialValues={initialValues} onSaved={setInitialValues} />;
};
